'use client';

import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { ThankYouForm } from './thank-you-form';

export default function ThankYouPage() {
  const navigate = useNavigate();
  const { communityId } = useParams<{ communityId: string }>();
  const [searchParams] = useSearchParams();

  const handleCancel = () => {
    if (searchParams.has('memberId') || searchParams.get('from') === 'members') {
      navigate(`/${communityId}/members`);
    } else {
      navigate(`/${communityId}/create`);
    }
  };

  const handleSubmit = (postId: string) => navigate(`/${communityId}/dashboard?postid=${postId}`);

  return (
    <div className="w-full max-w-5xl mx-auto px-0 md:px-4 py-0 md:py-8">
      <ThankYouForm onCancel={handleCancel} onSubmit={handleSubmit} />
    </div>
  );
}
